import React, { useState } from 'react'
import { useNotify, Spinner } from 'app/theme'
import { useMutation } from 'jsonapi-react'
import { Input, Submit } from 'app/theme/forms'
import { cleanPhone, formatPhone } from 'app/utils/phone'
import { isValidEmail } from 'lib/validation'

export default function Profile({ session }) {
  const notify = useNotify()
  const [validations, setValidations] = useState({})

  const [mutate, {
    data,
    setData,
    errors,
    isLoading,
  }] = useMutation(['users', session.user.id], {
    initialData: session.user,
  })

  const validate = () => {
    const errs = {}

    if (data.email && !isValidEmail(data.email)) {
      errs.email = 'Please enter a valid email address'
    }

    if (Object.keys(errs).length) {
      setValidations(errs)
      return false
    }

    return true
  }

  const onSubmit = () => {
    if (!validate()) {
      return
    }

    mutate({
      first_name: data.first_name,
      last_name: data.last_name,
      email: data.email,
      phone: cleanPhone(data.phone),
      title: data.title,
    }).then(res => {
      if (res.data) {
        session.refresh()

        notify.show({
          theme: 'success',
          title: 'Success',
          message: 'Profile was updated',
        })
      } else if (res.errors) {
        notify.show({
          theme: 'error',
          title: 'Error',
          message: 'Please correct the invalid fields.',
        })
      } else {
        notify.show({
          theme: 'error',
          title: 'Error',
          message: 'Unable to update profile.',
        })
      }
    })
  }

  return (
    <div className="bg-white rounded shadow p-5 md:p-8">
      <h1 className="text-2xl font-platform text-navy mb-5">
        My Account
      </h1>
      <div className="grid gap-6">
        <Input
          label="First Name"
          value={data.first_name}
          error={errors?.first_name?.[0]?.detail}
          onChange={first_name => setData(data => ({ ...data, first_name }))}
        />
        <Input
          label="Last Name"
          value={data.last_name}
          error={errors?.last_name?.[0]?.detail}
          onChange={last_name => setData(data => ({ ...data, last_name }))}
        />
        <Input
          label="Email"
          value={data.email}
          error={validations?.email || errors?.email?.[0]?.detail}
          onChange={email => {
            setData(data => ({
              ...data,
              email
            }))
            if (validations?.email) {
              setValidations({ ...validations, email: null })
            }
          }}
        />
        <Input
          label="Phone"
          value={data.phone}
          error={errors?.phone?.[0]?.detail}
          onChange={phone => {
            setData(data => ({
              ...data,
              phone: formatPhone(phone)
            }))
          }}
        />
        <Input
          label="Title"
          value={data.title}
          error={errors?.title?.[0]?.detail}
          onChange={title => {
            setData(data => ({
              ...data,
              title,
            }))
          }}
        />
        <div className="mt-3 pt-8 border-t border-gray-200 flex justify-center">
          <Submit
            type="submit"
            children="Save Changes"
            className="px-20 py-2 rounded-sm text-lg"
            onClick={onSubmit}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  )
}
